<template>
  <el-submenu :class="menu.name.length >= 24? 'menu-item-height-3' : 'menu-item-height-4'" v-if="menu.children && menu.children.length >= 1" :index="'' + menu.id">
    <template slot="title">
      <img v-if="menu.icon" :class="menu.name.length < 24? 'menu-icon-position-1' : 'menu-icon-position-2'" :src="require('@/' + menu.icon)"/>
      <span class="menu-span" slot="title">{{menu.name}}</span>
    </template>
    <MenuTree v-for="item in menu.children" :key="item.id" :menu="item"></MenuTree>
  </el-submenu>
  <el-menu-item :class="menu.name.length >= 24? 'menu-item-height-1' : 'menu-item-height-2'" v-else-if="menu.name != null && menu.name != ''" :index="'' + menu.id" @click="handleRoute(menu)">
    <img v-if="menu.icon != null && menu.icon != ''" :class="menu.name.length < 24? 'menu-icon-position-1' : 'menu-icon-position-2'" :src="require('@/' + menu.icon)"/>
    <span class="menu-span" slot="title">{{menu.name}}</span>
  </el-menu-item>
</template>

<script>
import { getIFrameUrl, getIFramePath } from '@/utils/iframe'
export default {
  name: 'MenuTree',
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleRoute (menu) {
      // 如果是嵌套页面，转换成iframe的path
      let path = getIFramePath(menu.url)
      if(!path) {
        path = menu.url
      }
      // 通过菜单URL跳转至指定路由
      this.$router.push("/" + path)
    }
  }
}
</script>

<style scoped lang="scss">

.menu-span {
  padding-left: 2px;
  line-height: 19px;
}

// 菜单图标高度
.menu-icon-position-1 {
  margin-top: 0;
  height:16px;
  width:16px;
}

.menu-icon-position-2 {
  height:16px;
  width:16px;
  margin-top: -20px;
}

// 不可下拉的菜单选项高度
.menu-item-height-1 {
  height: 56px;
  line-height: 56px;
}

.menu-item-height-2 {
  height: 42px;
  line-height: 42px;
}

// 可下拉的菜单选项高度
.menu-item-height-3 >>> .el-submenu__title {
  height: 56px;
  line-height: 56px;
}

.menu-item-height-3 >>> .el-submenu .el-menu-item {
  height: 56px;
  line-height: 56px;
}

.menu-item-height-4 >>> .el-submenu__title {
  height: 42px;
  line-height: 42px;
}

.menu-item-height-4 >>> .el-submenu .el-menu-item {
  height: 42px;
  line-height: 42px;
}
>>> .el-submenu__title i{
  color: #FFFFFF;;
}
</style>


// WEBPACK FOOTER //
// src/components/MenuTree/index.vue